import React from 'react';
import Img from 'gatsby-image';

const emitOnload = () => {
  if (window.emitter) {
    window.emitter.emit('imageLoaded');
  }
};

const MultiResolutionImage = ({
  image,
  style,
  backgroundColor,
  onLoad = null
}) => {
  return (
    // <img
    //   src={image.sizes.src}
    //   srcSet={image.sizes.srcSet}
    //   style={style || undefined}
    //   onLoad={e => {
    //     if (onLoad) {
    //       onLoad(e);
    //     }
    //     emitOnload(e);
    //   }}
    //   //backgroundColor={backgroundColor || `#b2b2b2`}
    // />
    <Img
      sizes={image.sizes}
      style={style || undefined}
      onLoad={e => {
        if (onLoad) {
          onLoad(e);
        }
        emitOnload(e);
      }}
      backgroundColor={backgroundColor || `#f3f3f3`}
    />
  );
};

export default MultiResolutionImage;



// WEBPACK FOOTER //
// ./src/components/MultiResolutionImage.js